import { render, staticRenderFns } from "./occurForm.vue?vue&type=template&id=22205402"
import script from "./occurForm.vue?vue&type=script&lang=js"
export * from "./occurForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22205402')) {
      api.createRecord('22205402', component.options)
    } else {
      api.reload('22205402', component.options)
    }
    module.hot.accept("./occurForm.vue?vue&type=template&id=22205402", function () {
      api.rerender('22205402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/occurForm.vue"
export default component.exports